import React, { useEffect, useRef, useState } from 'react';
import { InputAdornment } from '@mui/material';
import { TextField } from 'new/elements/TextField';
import { Search as SearchIcon } from '@mui/icons-material';
import { Table } from 'new/elements/Table';

import styles from './UsersShared.module.scss';
import { Subheader } from 'new/elements/Subheader';
import { columns } from './columns';
import { User } from 'new/entities/User';
import { useDistance } from 'new/hooks/useDistance';
import { useLocation } from 'react-router-dom';
import { filterBy } from 'new/utils/filterBy';
import { ScreenConfig } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_COLLABORATE_SHARED_USERS } from 'new/constants/pathnames';

interface UsersProps {}

function Search({ onSearchChange }) {
  return (
    <TextField
      label=""
      onChange={onSearchChange}
      placeholder="Search users"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}

export function UsersShared(props: UsersProps) {
  const { state } = useLocation<{ users: User[] }>();
  const { users } = state;
  const [search, setSearch] = useState('');
  const [filteredUsers, setUsers] = useState(users);
  const ref = useRef();
  const tableHeight = useDistance(ref, 400);
  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    setUsers(users.filter(filterBy(search, 'name')));
  }, [search]);

  return (
    <div>
      <div className={styles.header} ref={ref}>
        <Subheader
          title="Users shared resources to"
          RightComponent={<Search onSearchChange={onSearchChange} />}
        />
      </div>
      <Table height={tableHeight} rowHeight={64} columns={columns} rows={filteredUsers} />
    </div>
  );
}

UsersShared.screenConfig = {
  screenName: 'UsersShared',
  path: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE_SHARED_USERS}`,
  domain: 'collaborate',
} as ScreenConfig<React.FC<UsersProps>>;
